var new_date = new Date(
  new Date().setDate(new Date().getDate() + 30)
).toLocaleDateString('fr');
const siteTitle = 'Terminez votre commande';

export default {
  mainTexts: {
    siteTitle: `${siteTitle}`,
    formTitle1: 'Remplissez vos informations',
    formTitle2: 'Faire une commande',
    btnForm: 'Continuer',
    btnForm2: 'Payer',
    priceText1: 'Paiement',
    priceText2: 'Total',
    footerTitle: 'Paiement en ligne',
    footerText: 'Confirmez avec votre carte de crédit',
    shippingInfoText: "Informations d'expédition et de facturation",
    paymentInfoText: 'INFORMATIONS DE PAIEMENT',
    agreengText:
      "En cliquant sur « Continuer », je confirme avoir lu, consenti et accepté les Termes et Conditions, la Politique de Confidentialité, et que j'ai au moins 18 ans.",
    checkboxText:
      "J'accepte de recevoir des notifications de newsletters, des offres et des services de communication.",
    bigFooterText: `Grâce à votre adhésion, vous participez également à notre concours pour gagner le ${siteTitle}. Nous sélectionnons un gagnant parmi 600 participants. Le prochain gagnant sera sélectionné le ${new_date} et sera averti directement par e-mail. Si la récompense est en rupture de stock, le gagnant recevra à la place un produit similaire de valeur égale ou supérieure.`,
    bigFooterText1: `Nous veillons à ce que nos membres disposent d'un historique détaillé des transactions et, de ce fait, ils savent ce pour quoi ils paient. Les informations de carte de crédit ne sont requises que pour faciliter les achats futurs. Il n'y aura aucun frais sur votre relevé de carte de crédit si vous ne passez pas à l'abonnement PREMIUM et n'effectuez pas d'achat.`,
    bigFooterText2: `En rejoignant ce service, vous bénéficierez d'un essai de 5 jours du programme de notre partenaire. Si vous poursuivez un abonnement au-delà de la période d'essai de 5 jours, un montant vous sera débité sur votre carte bancaire qui varie en fonction du choix du tarif. Lorsque votre contribution sera prélevée sur votre carte bancaire ou autre moyen de paiement, vous aurez accès à ces services qui sont réservés exclusivement aux membres du site internet de notre partenaire.`,
    subtotalText: 'Sous-total',
    amountText: 'Montant à payer',
    shippingText: 'Expédition',
    totalText: 'Total',
    freeText: 'Gratuit',
    countryLabel: 'Pays',
    country: 'France',
  },
  home: {
    placeholder: {
      firstName: 'Prenom',
      lastName: 'Nom de famille',
      email: 'Email',
      phone: 'Téléphone',
      city: 'Ville',
      address: 'Adresse',
      zip: 'Code postal',
      continue: 'Prochain',
      name: 'Nom',
    },
    cardNumber: 'Numéro de carte',
    expirationDate: "Date d'expiration",
    name: 'Nom',
    month: 'mois',
    year: 'année',
    cvv: 'CVV',
    confirmPayment: 'Effectuer un paiement',
    timer: "Délai restant jusqu'au paiement de la commande",
    labelNumber: 'Le numéro de la carte:',
    labelMonth: "Date d'expiration:",
    source:
      'Nous utilisons la sécurité 3D pour vérifier votre achat. Une nouvelle fenêtre de vérification de la transaction peut apparaître',
  },
  validation: {
    requireEmail: 'Votre email est vide',
    validEmail: 'Le courriel est invalide',
    requirePhone: 'Votre téléphone est vide',
    minPhone: 'Le champ du téléphone doit comporter au moins 10 caractères.',
    requireFirstName: 'Le prénom est requis.',
    validFirstName: 'Le prénom est invalide.',
    requireLastName: 'Le champ Nom de famille est obligatoire.',
    validLastName: "Le champ Nom de famille n'est pas valide.",
    requireCity: 'Il campo della città è richiesto.',
    validCity: 'Le champ de la ville est invalide.',
    requireAddress: "Le champ d'adresse est obligatoire.",
    validAddress: "Le champ d'adresse est invalide.",
    requireZip: 'Le champ code postal est obligatoire.',
    validZip: "Le champ zip n'est pas valide.",
    requireCard: 'Le champ du numéro de carte est obligatoire.',
    minCard: 'Pas assez de symboles.',
    validCard: 'Le champ du numéro de carte est invalide.',
    requireMonth: "Le champ mois d'expiration est requis.",
    requireYear: "Le champ année d'expiration est obligatoire.",
    requireName: 'Il est requis de compléter le champ correspondant au nom.',
    validName: "Le champ de nom n'est pas valide.",
    requireCvv: 'Le champ cvv est obligatoire.',
    validCvv: "Le champ CVV n'est pas valide.",
    minFirstName:
      'Le champ du premier nom doit comporter au moins 3 caractères.',
    minLastName:
      'Le champ du nom de famille doit comporter au moins 3 caractères.',
    minCity: 'Le champ de la ville doit comporter au moins 3 caractères.',
    minAddress: "Le champ d'adresse doit comporter au moins 3 caractères.",
    minZip: 'Le champ du code postal doit comporter au moins 3 caractères.',
    minName: 'Le champ du nom doit comporter au moins 3 caractères.',
    minCvv: 'Le champ cvv doit comporter au moins 3 caractères.',
    specialFirstName:
      'Le champ du prénom ne doit pas contenir de caractères spéciaux',
    specialLastName:
      'Le nom de famille du champ ne doit pas contenir de caractères spéciaux',
    specialName: 'Le nom du champ ne doit pas contenir de caractères spéciaux',
    specialCity:
      'La ville de terrain ne doit pas contenir de caractères spéciaux',
  },
  mask: {
    phone: '+33 9 99 99 99 99',
    zip: '99999',
    creditCard: '9999 9999 9999 9999',
    cvv: '9999',
  },
  getInTouch: {
    title: 'ENTRER EN CONTACT',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    email: 'E-mail',
    msg: 'Message',
    send: 'Envoyer',
    alreadyRegistered: 'Vous êtes déjà inscrit',
    unsubscribeLink: 'lien de désinscription',
    worktime: "Centre d'appels Fonctionne de 10h à 17h",
    phone: 'Téléphone: Sofia +359 2 437 4207',
  },
  footer: {
    title: "Participez avant qu'il ne soit trop tard",
    terms: 'Conditions générales',
    privacy: 'Politique de confidentialité',
    contact: {
      title: 'Contactez-nous',
      text: "Nous nous engageons à fournir à chacun de nos précieux clients un excellent service client. Si vous avez des questions ou des préoccupations, n'hésitez pas à contacter l'un de nos représentants du service clientèle professionnels",
    },
  },
};
